import React from 'react';
import PropTypes from 'prop-types';

import '../styles/index.scss';

const SlideWrapper = ({className, placement, fixed, shown, duration, children}) => {
  return (
    <div
      className={`${className || ''} SlideWrapper--container ${
        placement ? `SlideWrapper--${placement}` : 'SlideWrapper--top'
      } ${fixed ? 'SlideWrapper--fixed' : 'SlideWrapper--absolute'}`}
    >
      <div
        className={`SlideWrapper ${placement ? `SlideWrapper--${placement}` : 'SlideWrapper--top'} ${
          shown ? 'SlideWrapper--show' : 'SlideWrapper--hide'
        }`}
        style={{
          transitionDuration: duration ? `${duration}ms` : '1000ms',
        }}
      >
        {children}
      </div>
    </div>
  );
};

SlideWrapper.propTypes = {
  placement: PropTypes.oneOf(['top', 'left', 'right', 'bottom']),
  shown: PropTypes.bool,
  fixed: PropTypes.bool,
  duration: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default SlideWrapper;
